var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import InputUpCase from './InputUpCase';
// const -------------------------------------------------
export var PinErrorText = '請輸入正確的身分證號碼。';
var charNo = [
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'J',
    'K',
    'L',
    'M',
    'N',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'X',
    'Y',
    'W',
    'Z',
    'I',
    'O',
];
// func -------------------------------------------------
export var PinCheck = function (value) {
    if (!(value && value.length === 10)) {
        return false;
    }
    var sum = 0;
    var coeff = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1];
    var index = charNo.indexOf(value[0]);
    if (index > -1) {
        var x = (index + 10).toString();
        var varible_1 = [
            x[0],
            x[1],
            value[1],
            value[2],
            value[3],
            value[4],
            value[5],
            value[6],
            value[7],
            value[8],
            value[9],
        ];
        coeff.forEach(function (obj, idx) {
            sum += obj * parseFloat(varible_1[idx]);
        });
        if (sum % 10 === 0) {
            return true;
        }
    }
    return false;
};
export var PinError = function (value) { return !PinCheck(value); };
export var MultiPinCheck = function (value) {
    return value.split(',').findIndex(function (obj) { return PinError(obj); }) === -1;
};
export var MultiPinError = function (value) { return !MultiPinCheck(value); };
// main -------------------------------------------------
var InputPin = function (props) {
    var minLength = 10;
    var maxLength = 10;
    var _a = props.verifiers, verifiers = _a === void 0 ? [] : _a, other = __rest(props, ["verifiers"]);
    verifiers.push({ func: PinError, text: PinErrorText });
    return (React.createElement(InputUpCase, __assign({}, other, { minLength: minLength, maxLength: maxLength, verifiers: verifiers })));
};
export default InputPin;
